// import { defineStore } from 'pinia'
// import { GoogleAuthProvider } from 'firebase/auth'
// import { getRedirectResult, signInAnonymously, signInWithPopup, signInWithRedirect, signOut } from 'firebase/auth'
import { GoogleAuthProvider, signInWithPopup, signInWithRedirect, signOut } from "firebase/auth"
import { collection, doc, getDoc, query, where } from "firebase/firestore"
import type { RouteLocationNormalized } from "vue-router"
import { getCurrentUser, useCurrentUser, useIsCurrentUserLoaded, useFirebaseAuth } from "vuefire"

const UAvatar = resolveComponent("UAvatar")

// finally git makes some sense

// import { signInWithPopup, signOut, GoogleAuthProvider } from 'firebase/auth' //getRedirectResult, signInWithRedirect,
// import { type RouteLocationNormalized } from 'vue-router'
// import { useMainStore } from '~/stores/main'
// import { collection, doc, getCountFromServer, getDoc, limit, query, where } from 'firebase/firestore'
// import { useRouter } from 'nuxt/app'

export const useUserStore = defineStore("user", () => {
	const DataStore = useDataStore()
	const router = useRouter()
	const db = useFirestore()
	const googleAuthProvider = new GoogleAuthProvider()
	const user_full = ref(<tsAppendableObj>{})
	const user_route_role_map = ref(<tsAppendableObj>[])
	const auth = useFirebaseAuth()
	const LangsStore = useLangsStore()
	// const user = useCurrentUser()
	// const isUserLoaded = useIsCurrentUserLoaded()

	function signinRedirect() {
		if (auth)
			signInWithRedirect(auth, googleAuthProvider)
				.catch((reason) => {
					console.error("Failed signinRedirect", reason)
				})
				.then(() => {
					if (router.currentRoute.value.redirectedFrom) {
						router.push(router.currentRoute.value.redirectedFrom.path)
					} else {
						router.push("/")
					}
				})
	}

	// onMounted(() => {
	//     getRedirectResult(auth).catch(reason => {
	//         console.error('Failed redirect result', reason)
	//         error.value = reason
	//     })

	//     // console.log(getRedirectResult(auth))
	// })

	async function signinPopup() {
		if (auth)
			signInWithPopup(auth, googleAuthProvider)
				.catch((reason) => {
					console.log("Failed signinPopup", reason)
				})
				.then(async () => {
					// const MainStore = useMainStore()
					const route = useRoute()

					// MainStore.initData(user.value)
					if (typeof route.query.redirect === "string") {
						// MainStore.initializeRoutes(route.query.redirect, {}, 'auth')
					} else {
						// MainStore.initializeRoutes('/libraries/all', {}, 'auth')
					}
				})
	}

	// // const error = ref(null)

	function signOutUser() {
		if (auth)
			signOut(auth)
				.catch((reason) => {
					console.log("Failed signOutUser", reason)
				})
				.then(() => {
					// const MainStore = useMainStore()
					// MainStore.terminate('signout')
					user_full.value = {}
					router.push("/" + LangsStore.context.lang_id)
				})
	}

	async function checkRoute(to: RouteLocationNormalized) {
		const user = await getCurrentUser()

		// console.log('checkRoute START', to.path)

		if (!user && !to.path.startsWith("/" + LangsStore.context.lang_id + "/user/signin")) {
			console.log("checkRoute", "no user, guarded page")
			// const MainStore = useMainStore()
			// MainStore.terminate('checkRoute')
			// const router = useRouter()
			// return router.push({
			// 	path: '/user/signin',
			// 	query: {
			// 		redirect: to.fullPath,
			// 	},
			// })
		} else if (!user) {
			console.log("checkRoute", "no user, signin page")
			return router.push({
				query: {
					redirect: to.path,
				},
			})
		} else {
			// console.log('checkRoute', 'user, ok', to.path, to.query)
			// const MainStore = useMainStore()
			// MainStore.initializeRoutes(to.path, to.query, 'checkRoute')
			// MainStore.initData(user)
		}
	}

	function singinCredentials(credentials: unknown, redirect_to: string) {
		console.log("singinCredentials NOT IMPLEMENTED", credentials, redirect_to)
	}

	function signUpByLink(credentials: unknown, redirect_to: string) {
		// signInWithRedirect(auth, googleAuthProvider)
		// 	.catch((reason) => {
		// 		console.error('Failed signinRedirect', reason)
		// 	})
		// 	.then(() => {
		// 		if (router.currentRoute.value.redirectedFrom) {
		// 			router.push(router.currentRoute.value.redirectedFrom.path)
		// 		} else {
		// 			router.push('/')
		// 		}
		// 	})
	}

	async function initUserRoles(user: any) {
		const docRef = doc(db, "users_roles", user.uid)
		const user_roles = await getDoc(docRef)
		// console.log("initUser", user.uid, user_roles.data())
		user_full.value = { auth: user, roles: user_roles.data() || {} }
	}

	function listenForRoleChanges(user: any) {
		// This function should only be called on the client.
		if (import.meta.server || !user) return

		const userRolesRef = doc(db, "users_roles", user.uid)
		const reactiveRoles = useDocument(userRolesRef)

		watch(reactiveRoles, (newRoles) => {
			if (user_full.value.auth) {
				user_full.value.roles = newRoles || {}
			}
		})
	}

	const users_columns = computed(() => {
		const out = [
			// {
			// 	accessorKey: "id",
			// 	header: "ID",
			// 	cell: ({ row }) => DataStore.holders_vuefire["users_public"].find((el) => el.id === row.original.id)?.email,
			// },
			{
				accessorKey: "user",
				header: "User",
				cell: ({ row }) => {
					const user = DataStore.holders_vuefire["users_public"].find((el: any) => el.id === row.original.id)
					return h("div", { class: "flex items-center gap-3" }, [
						h(UAvatar, {
							src: user.photoURL,
							size: "lg",
						}),
						h("div", undefined, [
							h("p", { class: "font-medium text-highlighted" }, user.displayName),
							h("p", { class: "" }, `@${user.email}`),
							// h("p", { class: "" }, `@${user.photoURL}`),
						]),
					])
				},
			},
		]
		if (DataStore.holders_vuefire["users_roles"] && DataStore.holders_vuefire["users_roles"].length > 0) {
			for (const users_role of Object.keys(DataStore.holders_vuefire["users_roles"][0])) {
				out.push({
					accessorKey: users_role,
					header: users_role,
					cell: ({ row }) => row.original[users_role],
				})
			}
		}

		return out

		// {
		// 	accessorKey: "email",
		// 	header: "Email",
		// },
		// {
		// 	accessorKey: "company",
		// 	header: "Company",
		// 	cell: ({ row }) => row.original.company.name,
		// },
	})

	async function destroyLocalData(user: any) {
		// const user_role =
		console.log("destroyLocalData", "NOT IMPLEMENTED")
		// const docRef = doc(db, "users_roles", user.uid)
		// const user_rolez = await getDoc(docRef)
		// console.log("initUser", user.uid, user_rolez.data())
		// user_full.value = { auth: user, claims: user_rolez.data() }
	}

	return {
		checkRoute,
		signinPopup,
		signOutUser,
		signUpByLink,
		singinCredentials,
		signinRedirect,
		initUserRoles,
		listenForRoleChanges,
		destroyLocalData,

		user_full,
		user_route_role_map,
		users_columns,
	}
})

// if (import.meta.hot) {
// 	import.meta.hot.accept(acceptHMRUpdate(useUserStore, import.meta.hot))
// }
